<div (window:resize)="onResize($event)">
	<!-- Horizontal Desktop: Header + Hauptmenü in einer Zeile -->
	<ng-container *ngIf="layout === 'horizontal' && isMobile === false">
		<div class="mh3-unified-topbar">
			<app-horizontalnav></app-horizontalnav>
			<app-header-horizontal></app-header-horizontal>
		</div>
	</ng-container>

	<!-- Vertikal oder mobil: klassischer Aufbau -->
	<ng-container *ngIf="layout === 'vertical' || isMobile === true">
		<app-header></app-header>
		<app-verticalnav *ngIf="layout === 'vertical' || isMobile === true"></app-verticalnav>
	</ng-container>
</div>
